import Overlay from '../components/overlay';

const AppointmentOverlay = new Overlay($('#terminanfrage'));
const ApplicationOverlay = new Overlay($('#application'));

export { AppointmentOverlay, ApplicationOverlay};